var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Notifications.Container = function (superClass) {
  extend(Container, superClass);
  function Container() {
    return Container.__super__.constructor.apply(this, arguments);
  }
  Container.prototype.template = 'notifications/templates/notifications_container';
  Container.prototype.initialize = function () {
    return this.render();
  };
  Container.prototype.render = function () {
    var list;
    list = new Aedu.Notifications.ListView();
    this.$el.html(JST[this.template]());
    this.ui = {
      $listLocation: this.$('.js-notification-list-location')
    };
    return this.ui.$listLocation.html(list.$el);
  };
  return Container;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;